







































































import { Component, Prop, Mixins } from "vue-property-decorator";
import UtilMixin from "@/mixins/utilMixin";
import { Billing } from "@/model/agreement/billing";
import { USE_DIV, SEND_RECEIPT_SYSTEM_DIV } from "@/consts/const";
import TR from "@/components/contract/internal/Tr.vue";

@Component({
  components: {
    TR,
  },
})
export default class extends Mixins(UtilMixin) {
  /** 事業所請求情報 */
  @Prop({ default: {} as Billing }) billing!: Billing;

  /** 使用/未使用区分 */
  private USE_DIV = USE_DIV;

  /** 送る/送らない区分 */
  private SEND_RECEIPT_SYSTEM_DIV = SEND_RECEIPT_SYSTEM_DIV;

  /** 統一日付フォーマット */
  private DATE_FORMAT = "yyyy年MM月dd日";
}
